import LayoutGlobalActions from './LayoutGlobalActions.js';

var LayoutUserInfo = function LayoutUserInfo() {
  console.error('[CANVAS UI] Layout.UserInfo has been renamed Layout.GlobalActions please change to the new component. Layout.UserInfo will be removed in Canvas 5');
  return LayoutGlobalActions.apply(void 0, arguments);
};
LayoutUserInfo.displayName = 'Layout.UserInfo';

// Adds other Layout.GlobalActions options like context to it.
Object.assign(LayoutUserInfo, LayoutGlobalActions);

export { LayoutUserInfo as default };
